import Store from 'redux/store';
import {
  SEARCH_INITIAL,
  SEARCH_INITIAL_SUCCESS,
  SEARCH_INITIAL_FAIL,
} from 'redux/Reducers/Search/SearchReducer';
import { cloudloyalty } from '../clients';
import { ConvertObjectInStringParams } from '../../../Utils/createFiltersParams';
import { sortByName } from 'Utils/sort';

/* eslint-disable */
const FetchSearch = async (
  User,
  finallyCallback = () => { },
  { filters },
) => {
  Store.dispatch({ type: SEARCH_INITIAL, payload: { filter: filters } });
  cloudloyalty(User).get(`/v2/products?${ConvertObjectInStringParams(filters)}`).then((response) => {
    response = sortSearchResponse(response);

    Store.dispatch({
      type: SEARCH_INITIAL_SUCCESS,
      payload: {
        data: response,
      },
    });
  }).catch((e) => {
    Store.dispatch({
      type: SEARCH_INITIAL_FAIL,
      error: e,
    });
  })
    .finally(() => {
      finallyCallback();
    });
};

const sortSearchResponse = (response) => {
  if (!response || !response.data) return response;

  response.data.vendors = response.data.vendors.sort(sortByName);
  response.data.categories = response.data.categories.sort(sortByName);
  response.data.subcategories = response.data.subcategories.sort(sortByName);
  response.data.brands = response.data.brands.sort(sortByName);

  return response;
};

export default FetchSearch;
